var cordovaApp = {
  f7: null,
  /*
  This method hides splashscreen after 2 seconds
  */
  handleSplashscreen: function() {
    var f7 = cordovaApp.f7;
    if (!window.navigator.splashscreen || f7.device.electron) return;
    setTimeout(() => {
      window.navigator.splashscreen.hide();
    }, 2000);
  },
  /*
  This method prevents back button tap to exit from app on android.
  And allows to exit app on backbutton double tap
  */
  handleAndroidBackButton: function () {
    var f7 = cordovaApp.f7;
    if (f7.device.electron) return;
    cordovaApp.backButtonTimestamp = 0;   // seed so the first root back-press always toasts (never insta-exits)
    document.addEventListener('backbutton', function (e) {
      // if (new Date().getTime() - cordovaApp.backButtonTimestamp < 250) {
      //   cordovaApp.backButtonTimestamp = new Date().getTime();
      //   if (window.navigator.app && window.navigator.app.exitApp) {
      //     window.navigator.app.exitApp();
      //   }
      //   return true;
      // }
      // cordovaApp.backButtonTimestamp = new Date().getTime();
      e.preventDefault();
      // Back = dismiss the topmost overlay first, and stay on the current page.
      // Order is topmost-first (popover/actions stacked above a popup close before it).
      // Dialogs are intentionally excluded so back can't dismiss a non-cancelable loader.
      if (f7.$('.popover.modal-in').length)       { f7.popover.close(); return; }
      if (f7.$('.actions-modal.modal-in').length) { f7.actions.close(); return; }
      if (f7.$('.sheet-modal.modal-in').length)   { f7.sheet.close();   return; }
      if (f7.$('.popup.modal-in').length)         { f7.popup.close();   return; }
      if (f7.$('.panel.panel-in').length)         { f7.panel.close();   return; }

      // Nothing open → normal route back if this view has a previous page.
      var router = (f7.views.current || f7.views.main).router;
      if (router && router.history && router.history.length > 1) {
        router.back();
        return;
      }

      // On the root page (no page to go back to) → double-tap within 2s to exit.
      var now = new Date().getTime();
      if (now - cordovaApp.backButtonTimestamp < 2000) {
        if (window.navigator.app && window.navigator.app.exitApp) window.navigator.app.exitApp();
        return;
      }
      cordovaApp.backButtonTimestamp = now;
      f7.toast.show({ text: 'Press back again to exit', closeTimeout: 2000 });
    }, false);
  },
  /*
  This method does the following:
    - provides cross-platform view "shrinking" on keyboard open/close
    - hides keyboard accessory bar for all inputs except where it required
  */
  handleKeyboard: function () {
    var f7 = cordovaApp.f7;
    if (!window.Keyboard || !window.Keyboard.shrinkView || f7.device.electron) return;
    var $ = f7.$;
    window.Keyboard.shrinkView(false);
    window.Keyboard.disableScrollingInShrinkView(true);
    window.Keyboard.hideFormAccessoryBar(true);
    window.addEventListener('keyboardWillShow', () => {
      f7.input.scrollIntoView(document.activeElement, 0, true, true);
    });
    window.addEventListener('keyboardDidShow', () => {
      f7.input.scrollIntoView(document.activeElement, 0, true, true);
    });
    window.addEventListener('keyboardDidHide', () => {
      if (document.activeElement && $(document.activeElement).parents('.messagebar').length) {
        return;
      }
      window.Keyboard.hideFormAccessoryBar(false);
    });
    window.addEventListener('keyboardHeightWillChange', (event) => {
      var keyboardHeight = event.keyboardHeight;
      if (keyboardHeight > 0) {
        // Keyboard is going to be opened
        document.body.style.height = `calc(100% - ${keyboardHeight}px)`;
        $('html').addClass('device-with-keyboard');
      } else {
        // Keyboard is going to be closed
        document.body.style.height = '';
        $('html').removeClass('device-with-keyboard');
      }

    });
    $(document).on('touchstart', 'input, textarea, select', function (e) {
      var nodeName = e.target.nodeName.toLowerCase();
      var type = e.target.type;
      var showForTypes = ['datetime-local', 'time', 'date', 'datetime'];
      if (nodeName === 'select' || showForTypes.indexOf(type) >= 0) {
        window.Keyboard.hideFormAccessoryBar(false);
      } else {
        window.Keyboard.hideFormAccessoryBar(true);
      }
    }, true);
  },
  init: function (f7) {
    // Save f7 instance
    cordovaApp.f7 = f7;

    // Handle Android back button
    cordovaApp.handleAndroidBackButton();

    // Handle Statusbar
    cordovaApp.handleSplashscreen();

    // Handle Keyboard
    cordovaApp.handleKeyboard();
  },
};
export default cordovaApp;
